import useMediaQuery from '@mui/material/useMediaQuery';

// Compacte (touch-)layout: telefoon (staand én liggend) en iPad staand. Een
// smal desktopvenster (muis) valt er alleen onder als het echt telefoonbreed
// is, zodat desktop verder precies blijft zoals het was.
export const COMPACT_QUERY =
  '(max-width:599px), (pointer: coarse) and (max-width:899px), (pointer: coarse) and (max-height:599px)';

// Alleen telefoons (staand: smal; liggend: touch en laag). iPad valt hier
// niet onder. Voor het dashboard/de lijst: geen klok, grotere knoppen.
export const PHONE_QUERY = '(max-width:599px), (pointer: coarse) and (max-height:599px)';

export function useMobile() {
  const isMobile  = useMediaQuery('(max-width:599px), (pointer: coarse)');
  const isTablet  = useMediaQuery('(min-width:600px) and (max-width:899px)');
  const isDesktop = useMediaQuery('(min-width:900px)');
  // noSsr: meteen de juiste waarde bij de eerste render, anders flitst de
  // desktop-layout heel even voordat de compacte verschijnt
  const isCompact = useMediaQuery(COMPACT_QUERY, { noSsr: true });
  const isPhone = useMediaQuery(PHONE_QUERY, { noSsr: true });
  return { isMobile, isTablet, isDesktop, isCompact, isPhone };
}
